export function toLocalISODate(date: Date): string;
export function toLocalISODate(date: Date | null): string | null;
export function toLocalISODate(date: Date | null): string | null {
	return date ? toLocalISODateTime(date).substring(0, 10) : null;
}

function pad(num: number) {
	return String(num).padStart(2, "0");
}

export function toLocalISODateTime(date: Date): string;
export function toLocalISODateTime(date: Date | null): string | null;
export function toLocalISODateTime(date: Date | null): string | null {
	return date
		? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(
				date.getMinutes(),
		  )}:${pad(date.getSeconds())}.${pad(date.getMilliseconds())}`
		: null;
}
